import { NgIf } from "@angular/common";
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, OnInit, WritableSignal, signal } from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { first } from "rxjs";
import { ConfigService } from "src/app/servicios/config/config.service";
import { PlatformService } from "src/app/servicios/platform/platform.service";

@Component({
  selector: "app-banner-app-mv",
  templateUrl: "./banner-app-mv.component.html",
  styleUrls: ["./banner-app-mv.component.scss"],
  imports: [NgIf],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannerAppMvComponent implements AfterViewInit, OnInit {
  configBloque: any;
  fondoDegradado: WritableSignal<boolean>;
  cookieValue: WritableSignal<string>;
  mostrarBannerCookies: WritableSignal<boolean> = signal(false);
  constructor(
    private readonly platformService: PlatformService,
    private readonly configService: ConfigService,
    private readonly elementRef: ElementRef,
    private readonly cookieService: CookieService,
  ) {}

  ngOnInit(): void {
    const configPrensa = this.configService.getConfigPrensa();
    if (configPrensa) {
      configPrensa.pipe(first()).subscribe((resultConfig) => {
        if (resultConfig) {
          this.configBloque = resultConfig.general["app-banner-app-mv"];
          this.fondoDegradado = signal(this.configBloque.fondo_degradado === "true");
          const colorFondo = this.configBloque.color_fondo;

          if (this.fondoDegradado()) {
            const colorDegradado = this.configBloque.color_degradado;
            this.elementRef.nativeElement.style.setProperty("--background-image-url", "linear-gradient(" + colorFondo + ", " + colorDegradado + ")");
          } else {
            this.elementRef.nativeElement.style.setProperty("--background-image-url", colorFondo);
          }

          this.setDisplayStyleFromConfig("--popupMV", this.configBloque.pop_up_movil);
          this.setDisplayStyleFromConfig("--popupEscritorio", this.configBloque.pop_up_escritorio);
          this.setDisplayStyleFromConfig("--bannerMV", this.configBloque.banner_mv);
          this.setDisplayStyleFromConfig("--bannerEscritorio", this.configBloque.banner_escritorio);
        }
      });
    }
    if (this.platformService.isBrowser()) {
      this.cookieValue = signal(this.cookieService.get("popup-app"));
    }

    if (!this.cookieValue) {
      this.mostrarBannerCookies.set(true);
    }
  }

  ngAfterViewInit(): void {
    if (this.platformService.isBrowser()) {
      setTimeout(() => {
        this.cookieValue.set(this.cookieService.get("popup-app"));

        if (!this.cookieValue) {
          this.mostrarBannerCookies.set(true);
        }
      });
    }
  }

  guardarCookies(): void {
    this.mostrarBannerCookies.set(false);
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 15);
    this.cookieService.set("popup-app", "1", { expires: expirationDate });
  }

  setDisplayStyleFromConfig = (propertyName: string, configValue: string) => {
    const isTrue = configValue === "true";
    this.elementRef.nativeElement.style.setProperty(propertyName, isTrue ? "flex" : "none");
    return isTrue;
  };

  close(): void {
    this.setDisplayStyleFromConfig("--popupMV", "false");
    this.setDisplayStyleFromConfig("--popupEscritorio", "false");
    if (this.platformService.isBrowser()) {
      this.guardarCookies();
    }
  }
}
